import { PageTemplate } from "../styles";
import { DataContext } from "../DataContext";
import { useState, useContext, useEffect } from "react";
import SelectionModal from "../components/SelectionModal";
import ImageLoader from "../components/ImageLoader";
import { ASSET_URL } from "../constants";

const Gallery = () => {
  const { designs, visitedPages } = useContext(DataContext);

  // image loader
  const [imagesLoaded, setImagesLoaded] = useState(0);
  const [showLoading, setShowLoading] = useState(true);
  const totalImages = 30;
  const handleImageLoad = () => {
    setImagesLoaded((prev) => prev + 1);
  };

  const [selectedDesign, setSelectedDesign] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // component mount
  useEffect(() => {
    // failsafe to remove loader if not all images load
    setTimeout(() => {
      setShowLoading(false);
    }, 5000);
  }, []);

  useEffect(() => {
    if (imagesLoaded === totalImages) {
      setShowLoading(false);
    }
  }, [imagesLoaded, totalImages]);
  // image loader end

  const order = [
    "alaska",
    "twin-vistas",
    "summit-landing",
    "arizona",
    "red-barn-ranch",
    "3-peaks-golf",
    "upstream-fishing",
    "coral-reef-aquatics",
    "sunset-cove",
    "escape-everyday",
    "sky-ridge",
    "first-light",
    "dolphin-sail",
    "sand-sea",
    "southern-sands",
    "riverside-golf-center",
    "northern-lakes",
    "hiking-appalachian-trail",
    "pine-lakes",
    "key-west",
    "blue-wave-running-club",
    "freedom-jumping",
    "pacific-coast-highway",
    "coastal-mountain",
    "sky-safari",
    "explore-outdoors",
    "grand-canyon",
    "sahara-discovery",
    "embrace-serenity",
    "hawaiian-islands",
  ];

  const designArray = [];

  order.forEach((designName) => {
    const found = designs.find((design) => {
      return design.designName === designName;
    });
    designArray.push(found);
  });

  const renderDesigns = () => {
    return designArray.map((design) => {
      return (
        <button onClick={() => handleDesignSelection(design.designName)} key={design.designName}>
          <picture>
            <source srcset={`${ASSET_URL}/collection/${design.designName}.avif`} type="image/avif" />
            <img onLoad={handleImageLoad} src={`${ASSET_URL}/collection/jpg/${design.designName}.jpg`} alt={design.designTitle} />
          </picture>
        </button>
      );
    });
  };

  const handleDesignSelection = (designName) => {
    const selectedDesign = designs.find((design) => design.designName === designName);
    setSelectedDesign(selectedDesign);
    setShowModal(true);
  };

  const visited = visitedPages["/gallery"] > 1 ? true : false;
  const loading = showLoading && !visited;

  return (
    <>
      <PageTemplate className="large">
        <h2>Browse Our Design Collection</h2>
        <div className="content-page">
          <div className={`gallery-container ${loading && "loadingImages"}`}>
            <ImageLoader imagesLoaded={imagesLoaded} totalImages={totalImages} />
            {renderDesigns()}
          </div>
        </div>
      </PageTemplate>
      <SelectionModal
        selectedDesign={selectedDesign}
        setSelectedDesign={setSelectedDesign}
        showModal={showModal}
        setShowModal={setShowModal}
      />
    </>
  );
};

export default Gallery;
